import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Contex } from '../kzContex';

const PopularGames = () => {
    const { category } = useContext(Contex);

    // Hardcoded popular games based on the request screenshot
    const popularGamesNames = [
        "Wuthering Waves",
        "Honkai: Star Rail",
        "Zenless Zone Zero",
        "Mobile Legends: Bang Bang",
        "Garena Free Fire",
        "Genshin Impact",
        "Honor of Kings",
        "PUBG Mobile"
    ];

    const popularGames = category.filter(c => 
        popularGamesNames.some(name => c.description.toLowerCase().includes(name.toLowerCase()))
    ).slice(0, 8);

    if (popularGames.length === 0) return null;

    return (
        <div className="container popular-games-section mt-5">
            <h2 className="popular-title">Games Populer</h2>
            <div className="popular-grid">
                {popularGames.map((game) => (
                    <Link key={game.id} to={`/game/${encodeURIComponent(game.description)}`} className="popular-card">
                        <img src={game.image} alt={game.description} className="popular-card-img" />
                        <div className="popular-card-info">
                            <div className="popular-card-name text-truncate">{game.description}</div>
                            <div className="popular-card-dev text-truncate">{game.developer}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default PopularGames;
